import moment from 'moment'

const lang = document.querySelector('html').getAttribute('lang')
if(lang !== 'ar-ae') {
  moment.locale(lang)
} else {
  moment.locale('en')
  moment.updateLocale('en', {
    months: [
      'يناير',
      'فبراير',
      'مارس',
      'أبريل',
      'مايو',
      'يونيو',
      'يوليو',
      'أغسطس',
      'سبتمبر',
      'أكتوبر',
      'نوفمبر',
      'ديسمبر',
    ],
    monthsShort: [
      'يناير',
      'فبراير',
      'مارس',
      'أبريل',
      'مايو',
      'يونيو',
      'يوليو',
      'أغسطس',
      'سبتمبر',
      'أكتوبر',
      'نوفمبر',
      'ديسمبر',
    ],
    weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
    weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
    weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
    weekdaysParseExact: true,
    longDateFormat: {
        LT: 'HH:mm',
        LTS: 'HH:mm:ss',
        L: 'D/\u200FM/\u200FYYYY',
        LL: 'D MMMM YYYY',
        LLL: 'D MMMM YYYY HH:mm',
        LLLL: 'dddd D MMMM YYYY HH:mm',
    },
    meridiemParse: /ص|م/,
    isPM: function (input) {
        return 'م' === input;
    },
    meridiem: function (hour, minute, isLower) {
        if (hour < 12) {
            return 'ص';
        } else {
            return 'م';
        }
    },

  });
}

export const isDate = (value, haveTime) => {
  return typeof value === 'string'
    && value.split('-').length === 3
    && [2, 4].includes(value.split('-')[0].length)
    && value.split('-')[1].length === 2
    && value.split('-')[2].length === 2
    && (!haveTime || value.split('-')[2].split('T')[0].length === 2)
}

export const getDateOrValue = (value, format) => {
  const date = moment(value, format)
  const isValidDate = typeof value === 'string' && (value.includes('-') || value.includes('/')) && date.isValid() && value[0] !== '/' && !value.includes('http')
  return isValidDate ? date.valueOf() : value
}

export const formatDate = (date, formatFrom, formatTo) => {
  return moment(date, formatFrom).format(formatTo)
}

export const formatDateZone = (date, formatFrom, formatTo) => {
  return moment.parseZone(date, formatFrom).format(formatTo)
}

export const getDate = (date, formatFrom) => {
  return moment(date, formatFrom)
}

export const useDuration = moment.duration

export const dateRangeOverlaps = (a_start, a_end, b_start, b_end) => {
  if (a_start <= b_start && b_start <= a_end) return true;
  if (a_start <= b_end   && b_end   <= a_end) return true;
  if (b_start <  a_start && a_end   <  b_end) return true;
  return false;
}

export const getAlertsThatOverlapsStayDateRange = (stayDateStart, stayDateEnd, alertsList) => {
  let alertsListFiltered = []

  if (alertsList != null && alertsList.length >= 1) {
    alertsListFiltered = alertsList.filter((alert) => {
      if(dateRangeOverlaps(
            new Date(stayDateStart).getTime(),
            new Date(stayDateEnd).getTime(),
            new Date(alert.startDate).getTime(),
            new Date(alert.endDate).getTime()
        )) {
        return true
      }
      return false
    })
  }

  return alertsListFiltered
}

export const isValidMonthYearFormat = (input) => {
  const regex = /^\d{2}-\d{4}$/;
  return regex.test(input);
}

export const isMonthYearInPast = (monthYear) => {
  const [month, year] = monthYear.split('-');
  const inputDate = new Date(`${year}-${month}-01`);
  const currentDate = new Date();
  return inputDate < currentDate;
}

export const timeIn12h = (time) => {
  const [hours, minutes] = time.split(":");
  const hrs = parseInt(hours, 10);
  const isPM = hrs >= 12;
  const adjustedHours = isPM
    ? hrs > 12
      ? hrs - 12
      : hrs
    : hrs === 0
    ? 12
    : hrs;
  return `${adjustedHours}:${minutes} ${isPM ? "PM" : "AM"}`;
}
